import { render } from "./pharmacy_index.vue?vue&type=template&id=b9ea6f5c&scoped=true"
import script from "./pharmacy_index.vue?vue&type=script&lang=js"
export * from "./pharmacy_index.vue?vue&type=script&lang=js"

import "./pharmacy_index.vue?vue&type=style&index=0&id=b9ea6f5c&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ea6f5c"]])

export default __exports__